import { toBoolean } from '../lib/utils';

$(function() {
  // 要素を表示
  function showElement($target) {
    $target.removeClass('hidden');
    $target.attr('aria-hidden', 'false');
  }

  // 要素を非表示
  function hideElement($target) {
    $target.addClass('hidden');
    $target.attr('aria-hidden', 'true');
  }

  $('input[type="radio"][data-selector="customerCorporation"]').on('change', function(e) {
    const $this = $('input[type="radio"][data-selector="customerCorporation"]:checked');
    const f = toBoolean($this.val());
    if (f) {
      showElement($('[data-id="corporationNameRequired"]'));
    } else {
      hideElement($('[data-id="corporationNameRequired"]'));
    }
  }).trigger('change');
});
